import React from 'react';
import NoPagination from '../pagination/noPagination.jsx';
import env from '../../environment.js';
import './map-side-table.css';

// Tabla que acompaña al mapa en los 3 niveles de padron-mapas-list.js: título +
// conteo, buscador (subrayado, sin caja, como en el Figma), una franja opcional
// (`headerExtra`, solo la usa el nivel 2) y la tabla en sí.
// Vive dentro de su propio CardContainer (tarjeta separada del mapa).
const MapSideTable = React.forwardRef(
  ({ title, count, columns, data, blocking, searchValue, onSearchChange, searchPlaceholder, className, getRowProps, headerExtra }, ref) => (
    <div className={`map-side-table${className ? ` ${className}` : ''}`}>
      <div className="map-side-table-header d-flex justify-content-between align-items-start mb-3">
        <span style={{ fontSize: 16, fontWeight: 600, color: env.colors.neutral_900 }}>
          {title} <span style={{ color: env.colors.neutral_400, fontWeight: 500, fontSize: 15 }}>({count})</span>
        </span>
        {onSearchChange && (
          <div className="map-side-table-search no-print">
            <i className="fa fa-search" aria-hidden="true" />
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={searchValue}
              onChange={onSearchChange}
              aria-label={searchPlaceholder}
            />
          </div>
        )}
      </div>
      {headerExtra && <div className="map-side-table-header-extra no-print">{headerExtra}</div>}
      <NoPagination ref={ref} blocking={blocking} columns={columns} data={data} getRowProps={getRowProps}></NoPagination>
    </div>
  )
);

MapSideTable.displayName = 'MapSideTable';

export default MapSideTable;
